import React from 'react';

const TagNutriscore = ({ score = 'A', size = 'md' }) => {
  const scoreConfig = {
    'A': { bgColor: 'bg-green-700', textColor: 'text-white' },
    'B': { bgColor: 'bg-lime-400', textColor: 'text-white' },
    'C': { bgColor: 'bg-yellow-400', textColor: 'text-white' },
    'D': { bgColor: 'bg-orange-500', textColor: 'text-white' },
    'E': { bgColor: 'bg-red-600', textColor: 'text-white' }
  };

  const sizeConfig = {
    'sm': { height: 'h-8', textSize: 'text-sm', letterWidth: 'w-8' },
    'md': { height: 'h-10', textSize: 'text-lg', letterWidth: 'w-10' },
    'lg': { height: 'h-16', textSize: 'text-2xl', letterWidth: 'w-12' }
  };

  const normalizedScore = score?.toUpperCase();
  const sizeStyles = sizeConfig[size];
  const scores = ['A', 'B', 'C', 'D', 'E'];

  return (
    <div className={`${sizeStyles.height} flex rounded-xl mb-2`}>
      {scores.map((letter, index) => {
        const config = scoreConfig[letter];
        const isSelected = letter === normalizedScore;

        const styles = isSelected ? {
          marginLeft: "-4px",
          marginRight: "-2px",
          border: "1px solid white",
          transform: "scaleY(1.5)",
          borderRadius: "11px",
          width: "2.75em"
        } : {}


        return (
          <div
            key={letter}
            className={`
              ${sizeStyles.letterWidth}
              ${sizeStyles.height}
              ${config.bgColor}
              ${isSelected ? 'relative z-10' : 'filter brightness-90'}
              ${index === 0 ? 'rounded-l-xl' : ''}
              ${index === scores.length - 1 ? 'rounded-r-xl' : ''}
              flex items-center justify-center
              transition-all duration-300
              ${isSelected && 'transform scale-105'}
            `}
            style={{
              marginLeft: index > 0 ? '-2px' : '0', ...styles
            }}
          >
            <span className={`
              ${sizeStyles.textSize}
              ${config.textColor}
              font-bold
              ${isSelected ? 'drop-shadow-sm' : ''}
            `}>
              {letter}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TagNutriscore;